// import React, { useContext } from 'react';
// import { Navigate } from 'react-router-dom';
// import { AuthContext } from '../context/AuthContext'

// const ProtectedRoute = ({ children }) => {
//     const { authState } = useContext(AuthContext);

//     if (authState.loading) {
//         return <div>Loading...</div>;
//     }

//     if (!authState.isAuthenticated) {
//         return <Navigate to="/login" />;
//     }

//     return children;
// };

// export default ProtectedRoute;



// components/context/ProtectedRoute.js
import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

const ProtectedRoute = ({ children, role }) => {
  const { authState } = useContext(AuthContext);
  console.log('Required Role:', role);

  if (authState.loading) {
    return <div>Loading...</div>;
  }

  if (!authState.isAuthenticated) {
    return <Navigate to="/login" />;
  }

  if (role && !role.includes(authState.user.role)) {
    return <Navigate to="/accessdenied" />;
  }

  return children;
};

export default ProtectedRoute;

